import React from "react";

const normalizeErrors = (errs = []) =>
  errs.map((e) => Array.isArray(e) ? { code: e[0], fault: e[1], detail: e[2] } : e);

const RefusedList = ({ items }) => {
  if (!items?.length) {
    return <p className="text-gray-500 italic mt-2">— Sin rechazos —</p>;
  }

  return (
    <div className="mt-3 overflow-x-auto rounded-2xl border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-gray-700">
          <tr>
            <th className="px-4 py-2 text-left">LRN</th>
            <th className="px-4 py-2 text-left">ARC</th>
            <th className="px-4 py-2 text-left">Errores</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r, idx) => {
            const errs = normalizeErrors(r.errors);
            return (
              <tr key={`${r.arc || r.lrn || idx}-${idx}`} className="border-t">
                <td className="px-4 py-2">{r.lrn}</td>
                <td className="px-4 py-2">{r.arc}</td>
                <td className="px-4 py-2">
                  <details>
                    <summary className="cursor-pointer select-none">
                      {errs.length} {errs.length === 1 ? "error" : "errores"}
                    </summary>
                    <ul className="mt-2 space-y-2">
                      {errs.map((er, i) => (
                        <li key={i} className="rounded-lg bg-gray-50 p-2">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="inline-block rounded-md border px-2 py-0.5 text-xs">
                              {er.code}
                            </span>
                            <span className="text-sm font-medium">{er.fault}</span>
                          </div>
                          {er.detail && <p className="mt-1 text-xs text-gray-600">{er.detail}</p>}
                        </li>
                      ))}
                    </ul>
                  </details>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RefusedList;
